import { GetServerSideProps } from 'next/types';

import { Homepage as HomepageComponent } from 'components/homepage/Homepage';
import { WorkspaceService } from 'services/WorkspaceService';

const Homepage = () => {
    return <HomepageComponent />;
};

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
    const workspaceConfig = await WorkspaceService.getRequestConfig(req);

    if (workspaceConfig?.homepagePath) {
        return {
            redirect: {
                destination: workspaceConfig.homepagePath,
                permanent: false,
            },
        };
    }

    return {
        props: {},
    };
};

export default Homepage;
